module.exports = __webpack_public_path__ + "img/GMA.66def18f.jpg";